import { createPathResolver, pushUrl, setPageTitle } from '../shared/router.js';

let cachedConfig = null;

function memberNavConfig() {
    if (cachedConfig !== null) {
        return cachedConfig;
    }

    const el = document.getElementById('member-nav-config');
    if (!el || !el.textContent) {
        throw new Error('member-nav-config: script element is required');
    }
    try {
        cachedConfig = JSON.parse(el.textContent);
    } catch (err) {
        throw new Error('member-nav-config: invalid JSON');
    }

    return cachedConfig;
}

export function memberRoutes() {
    return memberNavConfig().routes || {};
}

export function memberPages() {
    return memberNavConfig().pages || {};
}

export function memberCongregationId() {
    return memberNavConfig().congregationId || null;
}

export function withMemberCongregationQuery(url) {
    const congregationId = memberCongregationId();
    if (!congregationId) {
        return url;
    }
    const sep = url.includes('?') ? '&' : '?';
    return url + sep + 'congregation_id=' + encodeURIComponent(congregationId);
}

export function memberResetHeader() {
    return memberNavConfig().resetHeader || {};
}

export function consumeOtpResendPrompt() {
    const config = memberNavConfig();
    const prompt = config.otpResendPrompt;
    config.otpResendPrompt = null;
    if (typeof prompt !== 'string') {
        return null;
    }
    const trimmed = prompt.trim();
    return trimmed === '' ? null : trimmed;
}

export const memberPagePath = createPathResolver(memberPages);

export const ACCOUNT_SETTINGS_PAGE_BY_TAB = {
    personal: 'accountSettingsPersonal',
    payment: 'accountSettingsPayment',
    'mi-sheberach': 'accountSettingsMiSheberach',
    appearance: 'accountSettingsAppearance',
    tax: 'accountSettingsTax',
    congregations: 'accountSettingsCongregations',
};

export const MEMBER_PAGE_TITLES = {
    home: 'Home',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    recoverPin: 'Recover PIN',
    donate: 'Donate',
    donateAmount: 'Donation Amount',
    donateFrequency: 'Donation Frequency',
    donateDetails: 'Donor Details',
    donatePayment: 'Payment',
    donateSavedCards: 'Saved Cards',
    donateCharity: 'Donate to Charity',
    pledges: 'My Pledges',
    pledgesPay: 'Pay Pledges',
    accountSettingsPersonal: 'Settings',
    accountSettingsPayment: 'Payment Methods',
    accountSettingsMiSheberach: 'Mi Sheberach',
    accountSettingsAppearance: 'Appearance',
    accountSettingsTax: 'Tax Documents',
    accountSettingsCongregations: 'Congregations',
    seating: 'Seating',
    seatingPlan: 'Seating Plan',
};

export function accountSettingsPageForTab(tab) {
    return ACCOUNT_SETTINGS_PAGE_BY_TAB[tab] || ACCOUNT_SETTINGS_PAGE_BY_TAB.personal;
}

export function accountSettingsTabFromPath(pathname) {
    const segment = String(pathname || window.location.pathname)
        .replace(/\/$/, '')
        .split('/')
        .pop();
    return Object.prototype.hasOwnProperty.call(ACCOUNT_SETTINGS_PAGE_BY_TAB, segment)
        ? segment
        : 'personal';
}

export function memberNavigateTo(page, params) {
    pushUrl(memberPagePath(page, params));
    setPageTitle(MEMBER_PAGE_TITLES[page]);
}
